export default __webpack_public_path__ + "static/media/Greenforecast.473a0d0a.png";